<template>
  <div class="roleBox">
    <div class="myTop">
      <el-breadcrumb style="line-height: 60px;margin-left: 30px;" separator="/">
        <el-breadcrumb-item :to="{ path: '/equipmentManager/equipmentTypeManager' }">设备管理</el-breadcrumb-item>
        <el-breadcrumb-item>维修工单</el-breadcrumb-item>
        <el-button type="primary" class="myBtn" @click="dialogVisible = true">新建</el-button>
        <el-button class="myBtn2">导出</el-button>

        <el-dialog title="新建工单" :visible.sync="dialogVisible" width="30%">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm">
            <el-form-item label="检修专业" prop="region">
              <el-select v-model="ruleForm.region" placeholder="请选择检修专业">
                <el-option
                  :label="item"
                  :value="item"
                  v-for="(item,index) in setProfessione"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属区域" prop="area">
              <el-select v-model="ruleForm.area" placeholder="请选择所属区域">
                <el-option :label="item" :value="item" v-for="(item,index) in setArea" :key="index"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="设备位号" prop="num">
              <el-select v-model="ruleForm.num" placeholder="设备位号">
                <el-option :label="item" :value="item" v-for="(item,index) in setNo" :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备名称" prop="name">
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>

            <el-form-item label="维修类别" prop="serType">
              <el-select v-model="ruleForm.serType" placeholder="请选择维修类别">
                <el-option :label="item" :value="item" v-for="(item,index) in setType" :key="index"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="维修内容" prop="desc">
              <el-input type="textarea" v-model="ruleForm.desc"></el-input>
            </el-form-item>

            <el-form-item label="施工单位" prop="unit">
              <el-input v-model="ruleForm.unit"></el-input>
            </el-form-item>

            <el-form-item label="开始时间" prop="beginTime">
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="beginTime"
                type="datetime"
                placeholder="选择开始时间"></el-date-picker>
            </el-form-item>

            <el-form-item label="结束时间" prop="finishTime">
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="finishTime"
                type="datetime"
                placeholder="选择结束时间"></el-date-picker>
            </el-form-item>

            <el-form-item label="作业票类型" prop="tieckType">
              <el-select v-model="ruleForm.setTicket" placeholder="请选择作业票类别">
                <el-option
                  :label="item"
                  :value="item"
                  v-for="(item,index) in setTicket"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="签票人" prop="checkPeo">
              <el-select v-model="checkPeos" multiple placeholder="请选择签票人">
                <el-option
                  v-for="(item,index) in peosoptions"
                  :key="index"
                  :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="验收人" prop="signPeo">
              <el-select v-model="signPeos" multiple placeholder="请选择验收人">
                <el-option
                  v-for="(item,index) in peosoptions"
                  :key="index"
                  :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-form>

          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
            <el-button @click="dialogVisible = false">取 消</el-button>
          </span>
        </el-dialog>
      </el-breadcrumb>
    </div>

    <!-- 顶部信息栏 -->
    <div class="roleHead">
      <!-- 合格状态选择 -->
      <el-select v-model="value" style="width: 114px; margin-right:10px" placeholder="合格状态">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"></el-option>
      </el-select>

      <!-- 时间选择 -->
      <el-time-picker
        is-range
        v-model="value1"
        range-separator="～"
        start-placeholder="下达时间开始"
        end-placeholder="下达时间截止"
        placeholder="选择时间范围"></el-time-picker>

      <!-- 收索框 -->
      <el-input placeholder="单位/位号/名称" v-model="inputVal" class="myInput">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </div>

    <!-- 表格内容 -->
    <el-table :data="tableData" stripe style="width: 100%;padding:10px 0 0 20px;">
      <el-table-column prop="orderNo" label="单号">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <div slot="reference" class="name-wrapper">
              <el-link
                type="primary"
                @click="handelShowInfo(scope.row.id,scope.row)">{{scope.row.orderNo}}</el-link>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="area" label="所属区域"></el-table-column>
      <el-table-column prop="deviceLedger" label="设备位号"></el-table-column>

      <el-table-column prop="deviceName" label="设备名称"></el-table-column>

      <el-table-column prop="serviceType" label="维修类别"></el-table-column>

      <el-table-column prop="constructionFactory" label="施工单位"></el-table-column>

      <el-table-column prop="playStartTime" label="计划开始时间" sortable width="196px"></el-table-column>

      <el-table-column prop="playEndTime" label="计划完工时间" sortable width="196px"></el-table-column>

      <el-table-column prop="finishTime" label="完工时间" sortable width="196px"></el-table-column>

      <el-table-column prop="status" label="状态" width="90px">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <div slot="reference" class="name-wrapper">
              <el-tag
                effect="dark"
                :type="scope.row.setTagType"
                size="medium">{{ scope.row.setTagWord }}</el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>

      <el-table-column prop="oper" label="操作" width="152px">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <div slot="reference" class="name-wrapper">
              <el-link type="primary" @click="finishWork(scope.row.id,scope.row)">完工</el-link>
            </div>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <!-- 弹出框 -->
    <el-dialog title="确认工单" :visible.sync="isVisible" width="30%">
      <el-form :model="setForm" ref="setForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="合格状态" prop="status">
          <el-select v-model="setForm.status" style="width: 100%">
            <el-option :value="0" label="合格"/>
            <el-option :value="1" label="不合格"/>
          </el-select>
<!--          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <div slot="reference" class="name-wrapper">
                <el-tag :value="0" :type=" ifPass ? 'success' :''" @click="ifPass=true">合格</el-tag>
                <el-tag :value="1" :type=" !ifPass ? 'success' :''" @click="ifPass=false">不合格</el-tag>
              </div>
            </el-popover>
          </template>-->
        </el-form-item>

        <el-form-item label="完工时间" prop="finishTime">
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="setForm.finishTime"
            type="datetime"
            placeholder="选择开始时间"></el-date-picker>
        </el-form-item>

        <el-form-item label="备注" prop="note">
          <el-input type="textarea" v-model="setForm.note"></el-input>
        </el-form-item>

        <el-form-item label="通知用户" prop="adviceUserId" v-if="!ifPass">
          <el-select v-model="setForm.user" multiple placeholder="请选择验收人">
                <el-option
                  v-for="(item,index) in peosoptions"
                  :key="index"
                  :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm2('setForm')">确定</el-button>
        <el-button @click="isVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 分页 -->
    <div class="block" style="position: relative;">
      <el-pagination
        style="position: absolute; right: 0; top: 0;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"></el-pagination>
    </div>

    <leftInfo
      v-if="isShowLeft"
      :currentid="currentId"
      :currentrow="currentRow"
      @ifClose="isShowLeft=false"/>
  </div>
</template>

<script>
import leftInfo from "./comps/leftInfo";
export default {
  data() {
    return {
      ifPass: true,
      isVisible: false,
      currentId: "",
      currentRow: {},
      isShowLeft: false,
      peosoptions: [],
      value10: [],
      beginTime: "",
      finishTime: "",
      ruleForm: {
        num: "",
        name: "",
        region: "",
        area: "",
        desc: "",
        setTicket: "",
        unit: "",
        beginTime: "",
        finishTime: "",
        checkPeo: "",
        signPeo: "",
        peooptions: [
          {
            value: "选项1",
            label: "黄金糕",
          },
          {
            value: "选项2",
            label: "双皮奶",
          },
          {
            value: "选项3",
            label: "蚵仔煎",
          },
          {
            value: "选项4",
            label: "龙须面",
          },
          {
            value: "选项5",
            label: "北京烤鸭",
          },
        ],
      },
      setForm: {
        isPass: true,
        finishTime: undefined,
        note: "",
        user: "",
      },
      rules: {
        name: [{ required: true, message: "请输入设备名称", trigger: "blur" }],
        area: [
          { required: true, message: "请选择所属区域", trigger: "change" },
        ],
        desc: [{ required: true, message: "请填写维修内容", trigger: "blur" }],
        num: [{ required: true, message: "请选择设备位号", trigger: "change" }],
        region: [
          { required: true, message: "请选择检修设备", trigger: "change" },
        ],
        serType: [
          { required: true, message: "请选择维修类型", trigger: "change" },
        ],
        unit: [
          { required: true, message: "请选择施工单位", trigger: "change" },
        ],
        // tieckType: [
        //   { required: true, message: "请选择作业票类型", trigger: "blur" }
        // ]
      },
      total: 10,
      setNo: [],
      setType: [],
      setArea: [],
      setTicket: [],
      setProfessione: [],
      peooptions: [],
      checkPeos: [],
      signPeos: [],
      dialogVisible: false,
      inputVal: "",
      options: [
        {
          value: "选项1",
          label: "合格",
        },
        {
          value: "选项2",
          label: "不合格",
        },
      ],
      value: "",
      restaurants: [],
      state: "",
      sizePage: 10,
      currentPage: 1,
      value1: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],
      tableData: [
        {
          orderNo: "",
          area: "",
          deviceLedger: "",
          deviceName: "",
          serviceType: "",
          constructionFactory: "",
          playStartTime: "",
          playEndTime: "",
          finishTime: "",
          status: "",
        },
      ],
    };
  },
  components: {
    leftInfo,
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let arr = this.$refs[formName].$options.propsData.model;
          let formdata = new FormData();
          formdata.append("area", arr.area);
          formdata.append("deviceLedger", arr.region);
          formdata.append("serviceType", arr.serType);
          formdata.append("deviceName", arr.name);
          formdata.append("serviceContext", arr.desc);
          formdata.append("constructionFactory", arr.unit);
          formdata.append("playStartTime", this.beginTime);
          formdata.append("playEndTime", this.finishTime);
          formdata.append("workTicket", arr.setTicket);
          formdata.append("acceptors", JSON.stringify(this.checkPeos));
          formdata.append("status", status);
          formdata.append("ticketMakers", JSON.stringify(this.signPeos));
          this.componentsMoudel.httpRequest
            .getRequestHander(
              this.componentsMoudel.getData("urls").addHandleMes
            )
            .openLoad()
            .startPost(formdata)
            .then((res) => {
              if (res.result == "success") {
                this.$message({
                  showClose: true,
                  message: "添加成功",
                  type: "success",
                });
                this.dialogVisible = false;
                this.deptGetInfo(1, 10);
              }
            });
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    submitForm2(setForm) {
      this.$refs[setForm].validate((valid) => {
        if (valid) {
          let arr = this.$refs[setForm].$options.propsData.model;
          // console.log(arr);
          let formdata = new FormData();
          if (this.setForm.isPass) {
            formdata.append("status", 0);
          } else if (!this.setForm.isPass) {
            formdata.append("status", 1);
          }
          if (arr.note !== "") {
            formdata.append("remark", arr.note);
          }
          if (arr.user !== "") {
            formdata.append("adviceUserId", arr.user);
          }
          formdata.append("finishTime", arr.finishTime);
          formdata.append("id", this.currentId);
          this.componentsMoudel.httpRequest
            .getRequestHander(this.componentsMoudel.getData("urls").editFinishWork)
            .openLoad()
            .startPost(formdata)
            .then((res) => {
              // console.log(res);
              if (res.result == "success") {
                this.$message({
                  showClose: true,
                  message: "修改成功",
                  type: "success",
                });
              }
              this.isVisible = false;
              this.deptGetInfo(1, 10);
            });
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    finishWork(id, row) {
      this.isVisible = true;
      this.currentId = id;
      // console.log(this.currentId)
    },
    handelShowInfo(id, row) {
      this.isShowLeft = true;
      this.currentId = id;
      this.currentRow = row;
      // console.log(id, row);
    },
    handleSelect(key, keyPath) {
      this.activeIndex = key;
    },
    handleClick(ev) {
      // console.log(ev);
    },
    handleSizeChange(val) {
      this.sizePage = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.deptGetInfo(this.currentPage, this.sizePage);
    },
    //获取位号信息
    getNo() {
      this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData("urls").getReportNo)
        .openLoad()
        .startGet()
        .then((res) => {
          res.body.data.forEach((item, index) => {
            this.setNo[index] = item.testReportNo;
          });
        });
    },

    //获取检修专业
    getProfession() {
      this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData("urls").getProfession)
        .openLoad()
        .startGet()
        .then((res) => {
          res.body.data.forEach((item, index) => {
            this.setProfessione[index] = item.name;
            this.deptGetInfo(1, 10);
          });
        });
    },
    //获取所有用户信息
    getAllUser() {
      this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData("urls").getAllUser)
        .openLoad()
        .startGet()
        .then((res) => {
          res.body.data.forEach((item, index) => {
            this.peosoptions[index] = {};
            this.peosoptions[index].name = item.nickname;
            this.peosoptions[index].id = item.id;
          });
        });
    },
    //获取检修区域
    getArea() {
      this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData("urls").getarea)
        .openLoad()
        .startGet()
        .then((res) => {
          res.body.data.forEach((item, index) => {
            this.setArea[index] = item.name;
          });
        });
    },

    //获取维修类别
    getType() {
      this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData("urls").getServiceType)
        .openLoad()
        .startGet()
        .then((res) => {
          res.body.data.forEach((item, index) => {
            this.setType[index] = item.name;
          });
        });
    },

    //获取作业票类型
    getTicket() {
      this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData("urls").getticketType)
        .openLoad()
        .startGet()
        .then((res) => {
          res.body.data.forEach((item, index) => {
            this.setTicket[index] = item.name;
          });
        });
    },

    //获取报修处理信息
    deptGetInfo(page, limit) {
      const that = this;
      let formdata = new FormData();
      formdata.append("curPage", page);
      formdata.append("limit", limit);
      this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData("urls").getHandleMes)
        .openLoad()
        .startPost(formdata)
        .then((res) => {
          this.tableData = res.body.data;
          this.total = res.body.data.length;
          this.tableData.forEach((item, index) => {
            if (item.status == 0) {
              this.tableData[index].setTagWord = "合格";
              this.tableData[index].setTagType = "success";
            } else if (item.status == 1) {
              this.tableData[index].setTagWord = "不合格";
              this.tableData[index].setTagType = "warning";
            }
          });
        });
    },
  },
  created() {
    this.getTicket();
    this.getArea();
    this.getNo();
    this.getAllUser();
    this.deptGetInfo(1, 10);
    this.getType();
    this.getProfession();
  },
};
</script>

<style scoped>
.roleBox {
  padding: 8px;
}
.el-menu-demo {
  padding: 10px 0 0 20px;
}
.margin {
  margin-bottom: 10px;
}
.el-input {
  width: 100px !important;
}
.roleHead {
  margin-bottom: 10px;
  position: relative;
}
.myInput {
  width: 200px !important;
  position: absolute;
  right: 0;
  top: 0;
}
.myTop {
  background-color: #ffffff;
  width: 89%;
  height: 60px;
  position: absolute;
  top: 0;
  right: 0;
}
.myBtn {
  position: absolute;
  top: 10px;
  right: 30px;
}
.myBtn2 {
  position: absolute;
  top: 10px;
  right: 130px;
}
.el-date-editor--datetime {
  width: 200px !important;
}

.el-input {
  width: 200px !important;
}
</style>
